import { render, staticRenderFns } from "./Incident.vue?vue&type=template&id=6998c511&scoped=true&"
import script from "./Incident.vue?vue&type=script&lang=js&"
export * from "./Incident.vue?vue&type=script&lang=js&"
import style0 from "./Incident.vue?vue&type=style&index=0&id=6998c511&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6998c511",
  null
  
)

export default component.exports